import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const accEntryCommentView = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] COMMENT_VIEW',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.comment('view', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryCommentAdd = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] COMMENT_ADD',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.comment('add', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryCommentDelete = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] COMMENT_DELETE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.comment('delte', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryCommentEdit = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] COMMENT_EDIT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.comment('edit', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const destroyComments = createAction('[COMMENTS] DESTROY_COMMENTS_LIST')
